/* eslint-disable react/prop-types */
import AnnouncementListComponent from "./announcement-list";
import * as announcementHelper from "@/common/announcement-helper";
function AnnouncementList({ announcements, className, status, admin }) {
  console.log({ status, announcements });
  return (
    <AnnouncementListComponent
      announcements={
        admin
          ? announcementHelper.sortAnnouncementByStatus(announcements)
          : announcements
      }
      admin={admin}
      className={className}
      status={status}
    />
  );
}

export default AnnouncementList;
